// extracted by mini-css-extract-plugin
export var carousel = "Collabs-module--carousel--e6944";
export var caseStudy = "Collabs-module--caseStudy--ba9c4";
export var collabs = "Collabs-module--collabs--b42e4";
export var copy = "Collabs-module--copy--0214d";
export var copyText = "Collabs-module--copyText--b45f5";
export var heading = "Collabs-module--heading--99e1a";
export var inner = "Collabs-module--inner--6a1a8";
export var stat = "Collabs-module--stat--72b62";
export var stats = "Collabs-module--stats--a7878";